module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h1"
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/acknowledgement"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/part01"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ART")]), _vm._v(" I. L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AKE")]), _vm._v(" V"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IEW")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/part01#h1"
    }
  }, [_vm._v("Waterfront Living at Its Best—and Strangest")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/part01#h2"
    }
  }, [_vm._v("Chicago Temple Chimes Still Honor Early Settler John Turner")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/part01#h3"
    }
  }, [_vm._v("John Peter Altgeld: Heroic Rags to Riches to Rags Story")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/part01#h4"
    }
  }, [_vm._v("North Side’s Own “Valley of Kings” Was the “Living End” for Many")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/part01#h5"
    }
  }, [_vm._v("Lake View Joins Chicago—and Not Everyone Is Cheering")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/part01#h6"
    }
  }, [_vm._v("Samuel Gross’s Business Included Eighteen Towns, Cyrano Novel")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/part01#h7"
    }
  }, [_vm._v("Streetcars, Trains Pulled It All Together on the Early North Side")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/part01#h8"
    }
  }, [_vm._v("When a Few Riverview Revelers Literally Died Laughing")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/part01#h9"
    }
  }, [_vm._v("Harms Park Was an Almost Nonstop Picnic for Fifty-four Years")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/part01#h10"
    }
  }, [_vm._v("Ultimate “Party Animal” Charlie Weber Left Plenty of Questions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/part01#h11"
    }
  }, [_vm._v("Guardsmen Went After Pancho Villa as Practice for Great War")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/part01#h12"
    }
  }, [_vm._v("First World War’s Front Lines Ran Down “Lincolnstrasse”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/part01#h13"
    }
  }, [_vm._v("Armistice Sent Neighbors Pouring into Streets to Celebrate, Fight")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/part01#h14"
    }
  }, [_vm._v("Twenties Roared through Lake View Despite Prohibition, Recession")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/part01#h15"
    }
  }, [_vm._v("Lake View Marked Fiftieth as War Again Broke Out in Europe")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/part01#h16"
    }
  }, [_vm._v("Local Germans Took the Lead in Wartime Bond Drives")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/part01#h17"
    }
  }, [_vm._v("Hitler Kin Sounded Warning about Uncle during Visit to Temple")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/part01#h18"
    }
  }, [_vm._v("North Side’s Own “Benedict Arnold” Didn’t Get Away with It")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/part01#h19"
    }
  }, [_c('i', [_vm._v("Enola Gay")]), _vm._v("’s Bomb Bays Blew Cover Off Local Soldier’s Secret")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/part01#h20"
    }
  }, [_vm._v("V-J Day Brought Cheers, Tears on Lake View Streets")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/part01#h21"
    }
  }, [_vm._v("For Some, D-Day Reenactment Fifty Years Later Was Far Too Real")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/part01#h22"
    }
  }, [_vm._v("When deValera Won One for Irish Freedom at Wrigley Field")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/part01#h23"
    }
  }, [_vm._v("March 17, 1948: The Night the Music, and Anne Hunt, Died")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/part01#h24"
    }
  }, [_vm._v("Lake View High’s Teachers Wrote Their Own Legends, Their Way")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/part01#h25"
    }
  }, [_vm._v("Lane Tech, Like Its Namesake, Was a Mix of Brains and Brawn")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/part01#h26"
    }
  }, [_vm._v("Olympic Legend Avery Brundage Made a Lasting Mark Here")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/part01#h27"
    }
  }, [_vm._v("1896 “Great Race” Wasn’t Much to Write Home About")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/part01#h28"
    }
  }, [_vm._v("“Where’s the Beef?” Cops Wondered in Spring of 1897")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/part01#h29"
    }
  }, [_vm._v("Arabs, Jews Still Pray for This Christian Couple a Century Later")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/part01#h30"
    }
  }, [_vm._v("Rube Goldberg Would Have Loved These Guys Back in the Day")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/part01#h31"
    }
  }, [_vm._v("Cop Shop, Ballpark, CHA Homes, Theater Prove Reincarnation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/part01#h32"
    }
  }, [_vm._v("1971 Indian “Uprising” Spreads from Ballpark to Missile Site")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/part01#h33"
    }
  }, [_vm._v("Archbishop Sheil Got Boys Boxing, Battled Bigotry and Fear")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/part01#h34"
    }
  }, [_vm._v("Early North Side Park Was Literally Scooped Out of Clay…")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/part01#h35"
    }
  }, [_vm._v("…and Clay Made Lake View Center of U.S. Terra Cotta Industry")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/part01#h36"
    }
  }, [_vm._v("Why Some Carpenters, Stable Owners Saw Future in Next World")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/part01#h37"
    }
  }, [_vm._v("“Yellow Kid” Weil Wished He’d Gone into Politics Instead of Jail")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/part01#h38"
    }
  }, [_vm._v("Swedish Roots Still Run Deep Enough for Two Visits by King")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/part01#h39"
    }
  }, [_vm._v("“Children’s Poet” Eugene Field Gone but Never Forgotten")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/part02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ART")]), _vm._v(" II. R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AVENSWOOD")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/part02#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Is Ravenswood a State of Mind or a Real Neighborhood?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/part02#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Unsung Civil War Hero May Have Helped Save Chicago")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/part02#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("For Last Trooper, Living Poor Here Was Worse than Indian Wars")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/part02#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("North Center Was Once Just That—the Center of the North Side")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/part02#h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Back in the Day, Ravenswood—not LA—Was for Star-Gazing")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/part02#h6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Faith Can Move Mountains—and Even Our Lady of Lourdes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/part02#h7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Abe Saperstein Began His Globetrotting Career at Welles Park")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/part02#h8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Famed Architect Louis Sullivan Wrapped Up His Career Here")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/part02#h9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Abbott’s First Lab Was Run Out of Town by Irate Neighbors")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/part02#h10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47"), _c('sup', [_vm._v("th")]), _vm._v(" Ward Was Scene of a Generation-Long “Duel of the Titans”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/part02#h11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“Inebriated, Opium-Eating Women” Helped at Washington Clinic")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/part02#h12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sweet Smell of Success Lingers On at Buffalo, Horner Parks")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/part02#h13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Channel Helped Clean Up after “Epidemic” that Never Happened")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/part02#h14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Three Brothers Who Became Admirals Got Their Start Here")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/part02#h15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Army’s Top Engineer Spent Decades Trying to Prove Innocence")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/part02#h16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Forgotten Musical Star’s Legacy Still Lives On at Local Library")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/part02#h17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Keeping Kids in School Was a Lifelong Battle for William Bodine")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/part02#h18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Curt Teich Brought the World Home with 265,000 Postcards")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/part02#h19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("North Center Radio Pioneer Tuned Out, Bet on Local Paper")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/part02#h20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“Hero” Turned Out to Be the Killer in Sensational Mystery Here")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/part02#h21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Memories of Temperance Groups, Local Militias Still on Display")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/part02#h22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ravenswood Women’s Club Was as Victorian as It Could Get")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/part02#h23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Was Bowmanville Named for Innkeeper Who Swindled Guests?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/part02#h24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ravenswood Residents Played Own Version of “Name Game”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/author",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31f1d30c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents.vue
// module id = 66
// module chunks = 0